module.exports = __webpack_public_path__ + "static/img/shaneSquare.ad9bb4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shaneSquare.png
// module id = jNTs
// module chunks = 1